/**
 * User-facing copy for the Hockey Canada integration toggle.
 *
 * Rendered through `capitalizeWords` at the call site per the Title Case
 * convention, so copy edits here can't drift out of case.
 */
export const HOCKEY_CANADA_MESSAGES = {
  enabled: 'Hockey Canada Integration Enabled',
  disabled: 'Hockey Canada Integration Disabled',
} as const
